import {
  LayoutDashboard, Search, FileText, Briefcase, MessageSquare, Wallet, User,
  Bell, LineChart, Send, Home, MoreHorizontal, Users, Building2, ShieldCheck,
  Receipt, ClipboardCheck, UserCheck, Settings, MessageCircle,
} from "lucide-react";

export const studentNav = [
  { key: "dash",    to: "/student",              end: true, label: "Dashboard",   icon: LayoutDashboard },
  { key: "find",    to: "/student/tasks",        label: "Find tasks",             icon: Search },
  { key: "apps",    to: "/student/applications", label: "My applications",        icon: FileText },
  { key: "alloc",   to: "/student/allocated",    label: "Allocated tasks",        icon: Briefcase },
  { key: "direct",  to: "/student/direct-work",  label: "Direct work",            icon: Send },
  { key: "chat",    to: "/workroom",             label: "Chat",                   icon: MessageSquare },
  { key: "earn",    to: "/student/earnings",     label: "Earnings",               icon: Wallet },
  { key: "profile", to: "/student/profile",      label: "Profile",                icon: User },
  { key: "notif",   to: "/notifications",        label: "Notifications",          icon: Bell },
];

export const companyNav = [
  { key: "dash",     to: "/company",          end: true, label: "Dashboard", icon: LayoutDashboard },
  { key: "post",     to: "/company/post",     label: "Post task",            icon: FileText },
  { key: "tasks",    to: "/company/tasks",    label: "My tasks",             icon: Briefcase },
  { key: "work",     to: "/workroom",         label: "Workrooms",            icon: MessageSquare },
  { key: "pay",      to: "/company/payments", label: "Payments",             icon: Wallet },
  { key: "disputes", to: "/disputes",         label: "Disputes",             icon: ShieldCheck },
  { key: "notif",    to: "/notifications",    label: "Notifications",        icon: Bell },
];

export const adminNav = [
  { key: "overview",  to: "/admin",              end: true, label: "Dashboard", icon: LayoutDashboard },
  { key: "students",  to: "/admin/students",     label: "Students",             icon: Users },
  { key: "companies", to: "/admin/companies",    label: "Companies",            icon: Building2 },
  { key: "kyc",       to: "/admin/kyc",          label: "KYC verification",     icon: UserCheck },
  { key: "gst",       to: "/admin/gst",          label: "GST verification",     icon: Receipt },
  { key: "find",      to: "/admin/find-tasks",   label: "Find tasks",           icon: Search },
  { key: "tasks",     to: "/admin/tasks",        label: "Task approval",        icon: ClipboardCheck },
  { key: "apps",      to: "/admin/applications", label: "Applications",         icon: FileText },
  { key: "alloc",     to: "/admin/allocation",   label: "Student allocation",   icon: Briefcase },
  { key: "direct",    to: "/admin/direct-work",  label: "Direct work",          icon: Send },
  { key: "chat",      to: "/workroom",           label: "Chat",                 icon: MessageSquare },
  { key: "whatsapp",  to: "/admin/whatsapp",     label: "WhatsApp Center",      icon: MessageCircle },
  { key: "pay",       to: "/admin/payments",     label: "Payments",             icon: Wallet },
  { key: "reports",   to: "/admin/analytics",    label: "Reports",              icon: LineChart },
  { key: "settings",  to: "/admin/settings",     label: "Settings",             icon: Settings },
];

export const studentBottomNav = [
  { key: "home",    to: "/student",             end: true, label: "Home", icon: Home },
  { key: "tasks",   to: "/student/tasks",       label: "Tasks",           icon: Search },
  { key: "work",    to: "/student/allocated",   label: "Work",            icon: Briefcase },
  { key: "chat",    to: "/workroom",            label: "Chat",            icon: MessageSquare },
  { key: "profile", to: "/student/profile",     label: "Profile",         icon: User },
];

export const companyBottomNav = [
  { key: "home",  to: "/company",          end: true, label: "Home", icon: Home },
  { key: "tasks", to: "/company/tasks",    label: "Tasks",           icon: Briefcase },
  { key: "post",  to: "/company/post",     label: "Post",            icon: FileText },
  { key: "work",  to: "/workroom",         label: "Chat",            icon: MessageSquare },
  { key: "pay",   to: "/company/payments", label: "Payments",        icon: Wallet },
];

export const adminBottomNav = [
  { key: "home",   to: "/admin",             end: true, label: "Home", icon: Home },
  { key: "users",  to: "/admin/students",    label: "Students",        icon: Users },
  { key: "find",   to: "/admin/find-tasks",  label: "Tasks",           icon: Search },
  { key: "direct", to: "/admin/direct-work", label: "Direct",          icon: Send },
  { key: "more",   to: "/admin/settings",    label: "More",            icon: MoreHorizontal },
];

export const navForRole = (role) =>
  role === "company" ? companyNav : role === "admin" ? adminNav : studentNav;

export const bottomNavFor = (role) =>
  role === "student" ? studentBottomNav :
  role === "company" ? companyBottomNav :
  role === "admin"   ? adminBottomNav   : [];
